var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g({staticClass:"eui-a-button",class:[_vm.variant ? `-${_vm.variant}`: '',
         _vm.color ? `-${_vm.color}`: '',
         _vm.size ? `-${_vm.size}`: '',
         {'-adaptSize': _vm.adaptSize},
         {'-iconOnly' : _vm.iconOnly},
         {'-selected' : _vm.selected},
         {'-disabled' : _vm.disabled}],attrs:{"disabled":_vm.disabled,"type":_vm.type}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }